export enum TipologiaDomandaModulo {
  aperta = 'APERTA',
  chiusa = 'CHIUSA',
  radio = 'RADIO'
}
